<template>
    <div class="camera" v-if="visible">
        <div class="content-box">
            <div class="comp-title">
                <span>拍照</span>
                <el-button icon="el-icon-close" circle @click="close"></el-button>
            </div>
            <div class="content-bottom">
                <div class="top-box">
                    <div class="image-list">
                        <div class="image-item" v-for="(item,index) in picList" :key="index" @click="">
                            <el-image
                                style="width: 110px; height: 83px"
                                :src="item"
                                :preview-src-list="picList">
                            </el-image>
                            <!--                            <img :src="item">-->
                            <div class="delete-item" @click.stop="deleteItem(index)">
                                <i class="el-icon-delete"></i>
                            </div>
                        </div>
                    </div>
                    <div class="button">
                        <el-button type="danger" style="width: 100%;" @click="camera">拍照</el-button>
                        <el-button type="primary" style="width: 100%" @click="save">保存</el-button>
                    </div>
                </div>
                <div ref="videoBox" class="video" style="width: 880px; height: 640px">
                    <video ref="videoEl" width="880" height="640" allow="camera;microphone" autoplay
                           style="background: #000;"></video>
                    <!--                    <div class="bottom-text">洗前 2024-07-06 18:05</div>-->
                    <div class="effect" :style="flag ? 'background-color: rgba(255,255,255,.5);' : ''"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { upload } from '@/utils/request';

export default {
    data() {
        return {
            visible: false,
            picList: [],
            keywords: null,
            flag: false
        };
    },
    methods: {
        // 打开弹窗
        show(pics, keywords) {
            this.visible = true;
            this.picList = pics ? pics.split('|') : [];
            this.keywords = keywords;
            const that = this;

            // 确认浏览器支持getUserMedia
            if (navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({
                    audio: false,
                    video: {
                        width: 880,
                        height: 640
                    }
                }).then(function(stream) {
                    that.$refs.videoEl.srcObject = stream; // 将视频流设置到<video>元素
                }).catch(function(err0r) {
                    console.log('获取摄像头错误：' + err0r);
                    that.$message.error('摄像头被占用，请先关闭占用摄像头的程序');
                });
            }
        },

        // 关闭弹窗
        close() {
            this.visible = false;
            // this.closeCamera();
        },

        // 保存
        save() {
            this.$emit('saveCamera', this.picList.join('|'), this.keywords);
            this.visible = false;
            this.closeCamera();
        },

        // 删除
        deleteItem(index) {
            this.picList.splice(index, 1);
        },

        // 拍照
        camera() {
            let canvas = document.createElement('canvas');
            canvas.width = this.$refs.videoEl.width;
            canvas.height = this.$refs.videoEl.height;
            let ctx = canvas.getContext('2d');
            ctx.drawImage(this.$refs.videoEl, 0, 0, canvas.width, canvas.height);
            let dataURL = canvas.toDataURL('image/png'); //base64格式的图片 url
            // 创建a标签下载图片
            let addElement = document.createElement('a');
            addElement.href = dataURL;

            var arr = dataURL.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }

            let formData = new FormData();

            const getCurrentDateTimeAsNumeric = () =>
                new Date().toISOString().slice(0, 19).replace(/-/g, '').replace(/:/g, '');

            formData.append('file', new File([u8arr], getCurrentDateTimeAsNumeric()+'.png', { type: mime }));
            if (this.flag) {
                return;
            } else {
                this.flag = true;
            }
            upload(`/mpp/image/upload`, formData).then((res) => {
                if (res.success) {
                    this.picList.push(res.url);
                    this.flag = false;
                }
            });
        },

        // 关闭摄像头
        closeCamera() {
            if (this.$refs.videoEl) {
                let tracks = this.$refs.videoEl.srcObject.getTracks();
                tracks.forEach(function(track) {
                    track.stop();
                });
            }
        }
    }
};
</script>

<style scoped lang="scss">
.camera {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .3);
    z-index: 200;

    .content-box {
        position: fixed;
        left: 50%;
        top: 50%;
        width: 900px;
        height: 900px;
        margin-left: -450px;
        margin-top: -450px;
        background-color: #fff;

        .comp-title {
            width: 100%;
            height: 60px;
            padding: 10px;
            border-bottom: 1px solid #ccc;
            background-color: #fff;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .content-bottom {
            width: 100%;
            padding: 10px;

            .top-box {
                width: 100%;
                height: 170px;
                margin-bottom: 10px;
                display: flex;

                .image-list {
                    width: 810px;
                    height: 100%;
                    margin-right: 10px;
                    overflow-y: scroll;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;

                    .image-item {
                        position: relative;
                        flex-shrink: 0;
                        width: 110px;
                        height: 83px;
                        margin-right: 10px;
                        margin-bottom: 10px;

                        img {
                            width: 100%;
                            height: 100%;
                        }

                        .delete-item {
                            position: absolute;
                            bottom: 0;
                            right: 0;
                            width: 30px;
                            height: 30px;
                            color: #fff;
                            background-color: #f56c6c;
                            border-top-left-radius: 10px;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }

                .button {
                    width: 145px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;

                    ::v-deep .el-button {
                        margin-left: 0;
                        height: 80px;
                    }
                }
            }

            .video {
                position: relative;

                .bottom-text {
                    position: absolute;
                    bottom: 10px;
                    right: 10px;
                    color: #fff;
                    font-size: 30px;
                }

                .effect {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                }
            }
        }
    }
}
</style>